import { RouteConfig } from 'vue-router';
import { importPage } from '@/utils/import';
export const routes: RouteConfig[] = [
  { path: '/car/add', component: importPage('car/add') },
  { path: '/car/temp', component: importPage('car/add') },
  { path: '/car/month', component: importPage('car/add') },
  { path: '/car/store', component: importPage('car/add') },
  { path: '/car/vip', component: importPage('car/add') },
  { path: '/car/car-arrears', component: importPage('car/car-arrears') },
  { path: '/car/car-arrears/:id', component: importPage('car/car-arrears') },
  { path: '/car/pay-car-arrears', component: importPage('car/pay-car-arrears') },
  { path: '/car/pay-car-arrears/:id/:license', component: importPage('car/pay-car-arrears') },
  { path: '/car/pay-car-arrears/:id/:license/:type', component: importPage('car/pay-car-arrears') },
  { path: '/car/pay-car-arrears/:id/:license/:type/:entryId', component: importPage('car/pay-car-arrears') },
  { path: '/car/arrears-pay', component: importPage('car/arrears-pay') },
  { path: '/car/arrears-pay/:id', component: importPage('car/arrears-pay') },
  { path: '/car/car-coupon', component: importPage('car/car-coupon') },
  { path: '/car/car-coupon/:carCouponMsg', component: importPage('car/car-coupon') },
  { path: '/car/car-coupon1', component: importPage('car/car-coupon1') },
  { path: '/car/car-coupon1/:carCouponMsg', component: importPage('car/car-coupon1') },
  { path: '/car/obtain-number', component: importPage('car/obtain-number') },
  { path: '/car/obtain-number/:callNumberLog', component: importPage('car/obtain-number') },
  { path: '/car/batch-reserve', component: importPage('car/batch-reserve') },
  { path: '/car/batch-reserve/:batchReserveMsg', component: importPage('car/batch-reserve') },
  { path: '/car/batch-reserve-error/:id', component: importPage('car/batch-reserve-error') },
  { path: '/car/car-coupon-seccess/:message', component: importPage('car/car-coupon-seccess') },
  { path: '/car/car-coupon-seccess/:message/:id', component: importPage('car/car-coupon-seccess') },
  { path: '/car/car-coupon-error/:id', component: importPage('car/car-coupon-error') },
  { path: '/car/pay', component: importPage('car/pay') },
  { path: '/car/pay/:license', component: importPage('car/pay') },
  // 欠费车辆，不缴费，再次跳转回来的支付页面
  { path: '/car/pay1/:license', component: importPage('car/pay1') },
  { path: '/car/test', component: importPage('car/test') },
  { path: '/car/test/:id', component: importPage('car/test') },
  { path: '/car/pay/now/:id', component: importPage('car/pay-now') },
  // 欠费车辆，不缴费，再次跳转回来的支付页面
  { path: '/car/pay-now1/:id', component: importPage('car/pay-now1') },
  { path: '/car/month/pay', component: importPage('car/pay-month') },
  { path: '/car/month/pay/:license', component: importPage('car/pay-month') },
  { path: '/car/month/pay/:license/:parkId', component: importPage('car/pay-month') },
  { path: '/car/store/pay', component: importPage('car/pay-store') },
  { path: '/car/store/pay/:license', component: importPage('car/pay-store') },
  { path: '/car/store/pay/:license/:ownerId', component: importPage('car/pay-store') },
  { path: '/car/list', component: importPage('car/list') },
  { path: '/car/rent', component: importPage('car/rent') },
  { path: '/car/add/unlicense', component: importPage('car/unlicense') },
  { path: '/car/pay-success', component: importPage('car/pay-success') },
  { path: '/car/invoice', component: importPage('car/invoice') },
  { path: '/car/reserve-online', component: importPage('car/reserve-online') },
  { path: '/car/reserve-online/:id', component: importPage('car/reserve-online') },
  { path: '/car/reserve-list', component: importPage('car/reserve-list') },
  //异常金额申述
  { path: '/car/handle-abnormal', component: importPage('car/handle-abnormal') },
  { path: '/car/handle-abnormal/:str', component: importPage('car/handle-abnormal') },
  //处理异常申述
  { path: '/car/handle-amount', component: importPage('car/handle-amount') },
  { path: '/car/handle-amount/:id', component: importPage('car/handle-amount') },
  //车主直接扫码，添加储值车辆
  { path: '/car/add-store', component: importPage('car/add-store') },
  { path: '/car/add-store/:id', component: importPage('car/add-store') },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routers/car.ts